<section
  class="relative py-24 px-6 lg:px-12 overflow-hidden"
  style="background: var(--theme-bg-alt)"
  aria-label="Call to action"
  *transloco="let t"
>
  <div class="dot-accent-tr" aria-hidden="true"></div>

  <div class="max-w-4xl mx-auto" style="position:relative;z-index:1">
    <div
      class="relative rounded-3xl overflow-hidden p-12 lg:p-20 text-center reveal"
      style="
        background: linear-gradient(
          135deg,
          rgba(0,140,240,0.13) 0%,
          rgba(0,52,163,0.18)  50%,
          rgba(0,140,240,0.09) 100%
        );
        border: 1px solid rgba(0,140,240,0.22);
      "
    >
      <!-- Top glow -->
      <div
        class="absolute inset-0 pointer-events-none"
        style="background:radial-gradient(ellipse at 50% -20%, rgba(0,140,240,0.22) 0%, transparent 55%)"
      ></div>

      <div class="relative" style="z-index: 10">
        <div class="section-label justify-center mb-6 reveal">Get Started</div>
        <h2
          class="font-display font-bold mb-5 reveal stagger-1"
          style="font-size:clamp(2rem,5vw,3.375rem);letter-spacing:-0.03em;line-height:1.1"
        >
          {{ t('home.ctaTitle') }}<br />
          <span class="gradient-text">{{ t('home.ctaSubtitle') }}</span>
        </h2>
        <p class="text-lg mb-10 max-w-xl mx-auto reveal stagger-2" style="color:var(--theme-text-dim)">
          {{ t('home.description') }}
        </p>
        <div class="flex flex-wrap justify-center gap-4 reveal stagger-3">
          <a
            [href]="freightLoginUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="btn-primary"
            (mousemove)="onMagnet($event)"
            (mouseleave)="onMagnetLeave($event)"
          >
            {{ t('home.freighMarketPlace') }}
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M7 17L17 7M17 7H7M17 7v10" />
            </svg>
          </a>
          <a
            href="#contactUs"
            class="btn-secondary"
            (mousemove)="onMagnet($event)"
            (mouseleave)="onMagnetLeave($event)"
          >
            {{ t('navbar.contact') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
